export default __webpack_public_path__ + "static/media/hand-holding-ball.29e89725.png";